import { Suspense, lazy, useState } from 'react'
import cc from 'classcat'

import WarningMessage from '../WarningMessage'
import storage from '../../utils/localStorage'

const CodeMirror = lazy(() => import(/* webpackChunkName: "codeMirror" */ '../CodeMirror'))

type Props = {
  value: string
  resetValue: string
  warningDismissKey: string
  onChange: (resetValue: string) => void
  onLint?: (errors: unknown[], editorValue: string) => void
  className?: string
  codeMirrorOptions?: Record<string, unknown>
  tScoped: TranslateProps['t']
  invalid?: boolean
}

export default function CodeEditor({
  value,
  resetValue,
  warningDismissKey,
  onChange,
  onLint,
  className,
  codeMirrorOptions,
  tScoped,
  invalid,
}: Readonly<Props>) {
  const [isWarningDismissed, setIsWarningDismissed] = useState(() => Boolean(storage.getItem(warningDismissKey)))

  return (
    <div className={cc(['ep-code-editor', className])}>
      {!isWarningDismissed && (
        <WarningMessage
          message={tScoped('warningMessage')}
          onDismiss={() => {
            setIsWarningDismissed(true)
            storage.setItem(warningDismissKey, '1')
          }}
        />
      )}

      <Suspense fallback={<div className="ep-code-editor-field" />}>
        <CodeMirror
          className="ep-code-editor-field"
          onChange={onChange}
          onLint={onLint}
          options={codeMirrorOptions}
          value={value}
          resizable
        />
      </Suspense>

      {invalid && (
        <div className="ep-code-editor-invalid-message">
          <span className="ep-code-editor-invalid-message-text">{tScoped(`validationMessages.invalidCode`)}</span>
        </div>
      )}

      <button className="ep-code-editor-reset-button" onClick={() => onChange(resetValue)} type="button">
        {tScoped('resetButton.label')}
      </button>
    </div>
  )
}
